export const MEDIA_OVERLAY_CLOSE_EVENT_NAME = 'close';
export const THUMBNAILS_FORCED_IMAGE_RATIO = '16x9';
export const THUMBNAILS_TOTAL_DISPLAY_AMOUNT = 6;
export const THUMBNAILS_THROTTLE_LIMIT = 300;
export const MEDIA_OVERLAY_THROTTLE_LIMIT = 300;
